export enum ProductTypes {
    DefaultProduct,
    Donation,
    Sofashield,
    LeatherCareKit,
    FabricCareKit,
    Sofaglide,
    SofaRescue
}